import { ThemeProvider } from 'styled-components';
import React from 'react';
import defaultTheme from './themes/default';

const StyledTheme = ({
  children,
  layout = 'default',
}: {
  children: React.ReactNode;
  layout: string;
}) => {
  const theme = React.useMemo(() => ({ ...defaultTheme, layout }), [layout]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
export default StyledTheme;
